import { Text } from "@mantine/core";

import AppLayout from "~/components/AppLayout";
import FuzzyBall from "~/components/FuzzyBall";

import classes from "./LandingPage.module.css";

export interface LandingPageProps extends SharedPageProps {
  announcement: string | null;
  isIosInAppBrowser: boolean;
  patternsDirectSafariLink: string | null;
}

const LandingPage: PageComponent<LandingPageProps> = ({
  announcement,
  isIosInAppBrowser,
  patternsDirectSafariLink,
}) => (
  <>
    <Stack pb="xl">
      {!!announcement && (
        <Container>
          <Alert icon={<NotificationIcon />}>{announcement}</Alert>
        </Container>
      )}
      <Container size="xs" py="xl">
        <Stack py="xs" ta="center">
          <FuzzyBall
            fuzzy="amber"
            breathing
            style={{ alignSelf: "center" }}
            w={200}
          />
          <Title lh={1.2} fz={44} className={classes.title}>
            Master the art of{" "}
            <span className={classes.bright}>
              navigating relationship conflict—together
            </span>
            .
          </Title>
          <Title size="h2">
            Learn techniques that{" "}
            <span className={classes.bright}>actually work</span>.
            <br />
            Build&nbsp;a{" "}
            <span className={classes.bright}>
              powerful&nbsp;connection
            </span>{" "}
            that&nbsp;lasts.
          </Title>
        </Stack>
      </Container>
    </Stack>
    <Box bg="white" py={62}>
      <Container size="xs">
        <Stack gap="xl" justify="center">
          <Stack gap="sm" c="dark" lh="xs" fz="xl">
            <Text inherit>
              Most people mistake relationship conflict as a&nbsp;
              <span className={classes.dark} style={{ whiteSpace: "nowrap" }}>
                zero-sum game
              </span>
              .
            </Text>
            <Text inherit>It&apos;s not.</Text>
            <Text inherit>
              If one of you loses,{" "}
              <span className={classes.dark}>you both lose</span>.
            </Text>
            <Text inherit>
              The fix is to change &quot;
              <span className={classes.dark}>me</span> vs.{" "}
              <span className={classes.dark}>you</span>&quot;
            </Text>
            <Text inherit>
              Into &quot;
              <span className={classes.dark}>us</span> vs.{" "}
              <span className={classes.dark}>negative patterns</span>&quot;.
            </Text>
          </Stack>
          <Button<"a" | typeof Link>
            size="lg"
            rightSection={<ContinueIcon />}
            fullWidth
            variant="filled"
            className={classes.button}
            {...(isIosInAppBrowser && patternsDirectSafariLink
              ? { component: "a", href: patternsDirectSafariLink }
              : { component: Link, href: routes.patterns.show.path() })}
          >
            What does a negative pattern look&nbsp;like?
          </Button>
        </Stack>
      </Container>
    </Box>
  </>
);

LandingPage.layout = page => (
  <AppLayout<LandingPageProps> padding={0}>{page}</AppLayout>
);

export default LandingPage;
